enum FieldType {
  CHECKBOX_FIELD = 'CHECKBOX_FIELD',
  CHECKBOX_GROUP = 'CHECKBOX_GROUP',
  SIGNATURE_FIELD = 'SIGNATURE_FIELD',
  TEXT_FIELD = 'TEXT_FIELD',
  ROOT = 'ROOT',
}

export default FieldType;
